import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { DayTask, TaskStatus } from "./types";
import { statusColor } from "./taskUtils";

export const TaskCard: React.FC<{ task: DayTask }> = ({ task }) => {
  const colors = statusColor(task?.status?.status as TaskStatus);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.75,
        bgcolor: "transparent",
        borderRadius: 1,
        border: "1px solid #E5E7EB",
        transition: "all 0.2s",
        overflow: "hidden",
        "&:hover": {
          bgcolor: "#EFF6FF",
          borderColor: "#BFDBFE",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Tooltip title={task?.name}>
        <>
          <Typography
            variant="body2"
            sx={{
              color: "#6366F1",
              fontWeight: 600,
              fontSize: 13,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {task?.bugKey}:
          </Typography>

          {/* Task Title */}
          <Typography
            variant="body2"
            sx={{
              color: "#111827",
              flex: 1,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              fontWeight: 400,
              fontSize: 13,
              minWidth: 0,
            }}
            title={task?.name}
          >
            {task?.name.length > 10
              ? `${task?.name.slice(0, 10)}...`
              : task?.name}
          </Typography>
        </>
      </Tooltip>
    </Box>
  );
};
